import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';

const Header = ({logoTheme}) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <header className="relative">
            {/* Container for logo and navigation */}
            <div className="mx-auto px-4 flex justify-between items-center mt-2 ml-2">
                {/* Logo */}
                {logoTheme === "dark" ? <img src="/images/footerFisiko.svg" alt='fisiko' /> : <img src="/images/fisko.svg" alt='fisiko' />}
                

                {/* Desktop Navigation Menu */}
                <nav className="hidden md:flex flex-grow justify-end items-center space-x-12">
                    <a href="#about-us" className="text-white hover:text-blue-500">About Us</a>
                    <a href="#features" className="text-white hover:text-blue-500">Features</a>
                    <a href="/contact" className="text-white hover:text-blue-500">Contact Us</a>
                    {localStorage.getItem("token") ? (
                        <a href='/home'>
                        <button className="bg-white text-black font-bold rounded-full py-2 px-6 
                        hover:bg-black hover:text-white transition">
                            Dashboard
                        </button>
                        </a>
                    ) : (
                        <>
                            <a href="/login" className="text-white hover:text-blue-500">Sign In</a>
                            <button className="bg-white text-black font-bold rounded-full py-2 px-6 
                            hover:bg-black hover:text-white transition">
                                <a href='/register'>SIGN UP</a>
                            </button>
                        </>
                    )}
                </nav>

                {/* Mobile Menu Button */}
                <button 
                    className="md:hidden p-2 text-black"
                    onClick={() => setIsOpen(!isOpen)}
                >
                    {isOpen ? <X size={30} /> : <Menu size={30} />}
                </button>

                {/* Mobile Navigation Menu */}
                <div className={`
                    absolute top-full left-0 right-0 
                    bg-white bg-opacity-95
                    md:hidden
                    transition-all duration-300 ease-in-out
                    z-50
                    ${isOpen ? 'opacity-100 visible' : 'opacity-0 invisible'}
                    `}
                >
                    <nav className="flex flex-col items-center py-6 space-y-4">
                        <a href="#about-us" className="text-black hover:text-blue-500">About Us</a>
                        <a href="#features" className="text-black hover:text-blue-500">Features</a>
                        <a href="/contact" className="text-black hover:text-blue-500">Contact Us</a>
                        {localStorage.getItem("token") ? (
                            <button className="bg-white text-black font-bold rounded-full py-2 px-6 
                            hover:bg-black hover:text-white transition w-32">
                                <a href='/home'>Dashboard</a>
                            </button>
                        ) : (
                            <>
                                <a href="/login" className="text-black hover:text-blue-500">Sign In</a>
                                <button className="bg-black text-white font-bold rounded-full py-2 px-6 transition w-32">
                                    <a href='/register'>SIGN UP</a>
                                </button>
                            </>
                        )}
                    </nav>
                </div>
            </div>
        </header>
    );
};

export default Header;